var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2476_2783)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.42211 4.47687C1.17405 4.3804 1.05002 4.33216 1.01381 4.26266C0.982417 4.20241 0.982374 4.13064 1.01369 4.07036C1.04982 4.00081 1.1738 3.95243 1.42174 3.85567L8.45831 1.1097C8.68213 1.02235 8.79404 0.978678 8.86555 1.00257C8.92766 1.02331 8.97639 1.07205 8.99714 1.13416C9.02103 1.20567 8.97736 1.31758 8.89001 1.5414L6.14404 8.57796C6.04728 8.82591 5.9989 8.94989 5.92935 8.98602C5.86907 9.01733 5.7973 9.01729 5.73705 8.9859C5.66755 8.94969 5.61931 8.82566 5.52284 8.5776L4.4278 5.76177C4.40821 5.71141 4.39842 5.68624 4.3833 5.66503C4.3699 5.64624 4.35347 5.62981 4.33467 5.61641C4.31347 5.60129 4.2883 5.59149 4.23794 5.57191L1.42211 4.47687Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2476_2783"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocation);
export default __webpack_public_path__ + "static/media/IconLocation.28772c8bafb8b8620464de4afc895929.svg";
export { ForwardRef as ReactComponent };